<template>
  <div class="webWapBindOauth" v-if="otherUserData.length > 0">
    <div class="title_wrap">
      <h3>{{ language('userData.tipsText19') }}</h3>
    </div>
    <div>
      <el-form
        class="form"
        size="small"
        label-position="left"
        label-width="235px"
        :model="form"
        :rules="rules"
        ref="otherUserData"
      >
        <div v-for="(list, index) in otherUserData">
          <el-form-item
            :label="list.infoTitle"
            :prop="list.infoKey"
            v-if="list.infoStyle == 'radio' && list.isDisplay == 1"
          >
            <template v-if="list.infoStyle == 'radio'">
              <el-radio
                v-model="form[list.infoKey]"
                :label="radio.value"
                v-for="(radio, ind) in list.extraData.radioList"
                :disabled="
                  list.allowUpdate == 0 && list.infoValue ? true : false
                "
                >{{ radio.name }}</el-radio
              >
            </template>
          </el-form-item>
          <el-form-item
            v-if="
              form[list.infoKey] == 1 ||
              (form[list.infoKey] == '' && list.isShowList == 1)
            "
            v-for="(itmes, ind) in list.list"
            :label="itmes.infoTitle"
            :prop="itmes.infoKey"
          >
            <template v-if="itmes.infoStyle == 'text'">
              <el-input
                v-model="form[itmes.infoKey]"
                :style="
                  itmes.extraData.ruleName == 'address'
                    ? 'width: 500px'
                    : 'width: 200px'
                "
                :placeholder="'請輸入' + itmes.infoTitle"
                :disabled="
                  itmes.allowUpdate == 0 && itmes.infoValue ? true : false
                "
              ></el-input>
            </template>
            <template v-if="itmes.infoStyle == 'date'">
              <el-date-picker
                v-model="form[itmes.infoKey]"
                type="month"
                :placeholder="'請選擇' + itmes.infoTitle"
                :picker-options="pickerOptions"
                :default-value="defaultValue"
                :value-format="'yyyy-MM'"
                :disabled="
                  itmes.allowUpdate == 0 && itmes.infoValue ? true : false
                "
              >
              </el-date-picker>
            </template>
            <template v-if="itmes.infoStyle == 'select'">
              <el-select
                v-model="form[itmes.infoKey]"
                clearable
                :placeholder="'請選擇' + itmes.infoTitle"
                :disabled="
                  itmes.allowUpdate == 0 && itmes.infoValue ? true : false
                "
              >
                <el-option
                  v-for="(radio, ind) in itmes.extraData.radioList"
                  :key="radio.value"
                  :label="radio.name"
                  :value="radio.value"
                >
                </el-option>
              </el-select>
            </template>
            <template v-if="itmes.infoStyle == 'radio'">
            {{ itmes.allowUpdate}}{{ itmes.infoValue}}
              <el-radio
                v-model="form[itmes.infoKey]"
                :label="radio.value"
                :disabled="
                  itmes.allowUpdate == 0 && itmes.infoValue ? true : false
                "
                v-for="(radio, ind) in itmes.extraData.radioList"
                >{{ radio.name }}</el-radio
              >
            </template>
          </el-form-item>
        </div>
      </el-form>
      <div class="button">
        <el-button
          type="primary"
          @click="save"
          v-if="JSON.stringify(formV2) != JSON.stringify(form)"
          >{{ language("register.save") }}</el-button
        >
      </div>
    </div>
  </div>
</template>
<script>
import Dator from "../utils/censor.js";

export default {
  data() {
    return {
      otherUserData: [],
      pickerOptions: {
        disabledDate(time) {
          var date = new Date();
          var year = date.getFullYear() - 18;
          var month = date.getMonth();
          if (month == 0) {
            month = 12;
          }
          // var day = new Date(year, month, 0).getDate(); //拿取18年前的前一个月的那个月有多少天
          // return time.getTime() > new Date(`${year}/${month}/${day}`).getTime();
          return time.getTime() > new Date().getTime();
        },
      },
      defaultValue: "",
      form: {},
      formV2: {},
      rules: {},
    };
  },
  watch: {
    ssoSDK: {
      handler(o, n) {
        if (this.ssoSDK) {
          this.businessInfoGet();
        }
      },
      deep: true,
      immediate: true,
    },
    appTheme: {
      handler(o, n) {},
      deep: true,
      immediate: true,
    },
  },
  computed: {
    appTheme: function () {
      return this.$store.state.appData.appTheme;
    },
    ssoSDK: function () {
      return this.$store.state.appData.ssoSDK;
    },
    sdkInfo: function () {
      return this.$store.state.appData.sdkInfo;
    },
  },
  methods: {
    getdefaultValue() {
      var date = new Date();
      var year = date.getFullYear() - 18;
      var month = date.getMonth();
      if (month == 0) {
        month = 12;
      }
      var day = new Date(year, month, 0).getDate(); //拿取18年前的前一个月的那个月有多少天
      // this.defaultValue = new Date(`${year}/${month}/${day}`).getTime();
      this.defaultValue = new Date().getTime();
    },
    businessInfoGet() {
      oauthSDK
        .businessInfoGet()
        .then((res) => {
          let list = [];
          let form = {};
          for (let index = 0; index < res.length; index++) {
            if (
              res[index].infoStyle == "select" ||
              res[index].infoStyle == "radio"
            ) {
              if (res[index].infoValue !== "") {
                res[index].infoValue = res[index].infoValue * 1;
              }
            }
            if (res[index].isRequired == 1) {
              this.rules[res[index].infoKey] = [
                {
                  required: res[index].isRequired,
                  validator: this.checkValue,
                  trigger: "blur",
                },
              ];
            }
            form[res[index].infoKey] = res[index].infoValue;
            for (let t = 0; t < res[index].list.length; t++) {
              if (res[index].list[t].isRequired == 1) {
                this.rules[res[index].list[t].infoKey] = [
                  {
                    required: res[index].list[t].isRequired,
                    validator: this.checkValue,
                    trigger: "blur",
                  },
                ];
              }
              if (
                res[index].list[t].infoStyle == "select" ||
                res[index].list[t].infoStyle == "radio"
              ) {
                if (res[index].list[t].infoValue !== "") {
                  res[index].list[t].infoValue =
                    res[index].list[t].infoValue * 1;
                }
              }
              form[res[index].list[t].infoKey] = res[index].list[t].infoValue;
            }
            list.push(res[index]);
          }
          console.log(list, res);
          this.otherUserData = list;
          this.form = form;
          this.formV2 = JSON.parse(JSON.stringify(form));
          this.getdefaultValue();
        })
        .catch((err) => {
          console.log(err);
          this.user401(err);
        });
    },
    checkValue(rule, value, callback) {
      console.log(rule, value);
      if (value === "" || value == undefined) {
        callback(new Error("請輸入內容"));
      } else {
        if (rule.field.indexOf("childName") > -1) {
          let dator = new Dator.Dator();
          var re = /^[0-9]+$/;
          let ut = value.split("");
          var flag = false;
          var text = "";
          ut.forEach((v) => {
            if (re.test(v)) {
              flag = true;
              text = this.language("userInfo.datorErrText[6]");
            }
          });
          if (value) {
            dator.add(value, [
              {
                strategy: "checkStringFormat:2:4",
                errMsg: this.language("userInfo.datorErrText[1]"),
              },
              {
                strategy: "checkStringFormat:25:2",
                errMsg: this.language("userInfo.datorErrText[5]"),
              },
              // {
              //   strategy: "checkName",
              //   errMsg: this.language("userInfo.datorErrText[4]"),
              // },
              {
                strategy: "checkUserName",
                errMsg: this.language("userInfo.datorErrText[6]"),
              },
            ]);
          }
          if (!value) {
            callback(new Error(this.language("userInfo.datorErrText[1]")));
          } else if (flag) {
            callback(new Error(text));
          } else if (dator.getErrmsg()) {
            callback(new Error(dator.getErrmsg()));
          } else {
            callback();
          }
        } else {
          callback();
        }
      }
    },
    save() {
      let form = { ...this.form };
      this.$refs["otherUserData"].validate((valid) => {
        if (valid) {
          // console.log(1111);
          this.$emit("loading", true);

          oauthSDK
            .businessInfoUpdate(form)
            .then((e) => {
              this.$emit("loading", false);
              this.defalutToast(
                this.language("userInfo.operationSuccess"),
                "success"
              );
              this.businessInfoGet();
            })
            .catch((err) => {
              this.$emit("success", false);
              console.log(err);
              this.defalutToast(err.message);
              this.user401(err);
            });
        } else {
          this.defalutToast("請檢查輸入項");
          return false;
        }
      });
    },
  },
};
</script>
<style scoped>
.title_wrap h3 {
  font-size: 18px;
}
.title_wrap {
  border-bottom: 1px solid #bbbbbb;
  padding: 0 0 10px 0;
  margin-bottom: 20px;
}
.button {
  display: flex;
  justify-content: center;
}
</style>